import { Component, computed, inject, input, output } from '@angular/core';
import { CommonModule, Location, NgOptimizedImage } from '@angular/common';
import { TranslocoModule, TranslocoService } from '@ngneat/transloco';
import { Router } from '@angular/router';
import { StoreIdService } from '../../core/services/store-id.service';
import { ThemeService } from '../../core/services/theme.service';

@Component({
  selector: 'cwo-header-logo',
  standalone: true,
  imports: [CommonModule, NgOptimizedImage, TranslocoModule],
  templateUrl: './header-logo.component.html',
  styleUrl: './header-logo.component.scss',
})
export class HeaderLogoComponent {
  private themeService = inject(ThemeService);
  private translocoService = inject(TranslocoService);
  logoInfo = computed(() => {
    const { logo, altText } = this.themeService.theme() || {};
    return { logo, altText };
  });
  src = input<string>();
  altText = input<string | undefined>();
  hasFullWidth = input<boolean>(false);
  alignCenter = input<boolean>(false);
  staticSiteUrl = input<string>('');
  logoRedirectToStaticSite = input<boolean>(false);
  logoSrc = computed(() => this.logoInfo().logo || this.src());

  displayedAltText = computed<string>(() => {
    return this.altText() ?? this.translocoService.translate('shared_components.store_logo.store_logo');
  });

  readonly loadEvent = output();
  storeIdService = inject(StoreIdService);

  private router = inject(Router);
  private location = inject(Location);

  constructor() { }

  onLoad() {
    this.loadEvent.emit();
  }

  onClick() {
    if (!(this.logoRedirectToStaticSite() && this.staticSiteUrl())) {
      this.router.navigate(this.storeIdService.getRoutePathSegments(['menu']));
    } else {
      window.location.href = this.staticSiteUrl();
    }
  }
}
